import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import LatestEvents from './pages/LatestEvents';
import LatestColloquia from './pages/LatestColloquia';
import AllEvents from './pages/AllEvents';
import EventDetails from './pages/EventDetails';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<LatestEvents />} />
          <Route path="/latest-colloquia" element={<LatestColloquia />} />
          <Route path="/all-events" element={<AllEvents />} />
          <Route path="/event/:id" element={<EventDetails />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;